export default __webpack_public_path__ + "static/media/icon-sales.ce1c8435.svg";